/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AggregateQuestionTypeEnum {
    ContactForm = 'ContactForm',
    ConstantSum = 'ConstantSum',
    GroupRank = 'GroupRank',
    GroupRating = 'GroupRating',
    Matrix = 'Matrix',
    MaxDiff = 'MaxDiff'
}

